var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.details.newsTitle))]),_vm._v(" "),_c('div',{staticClass:"details",domProps:{"innerHTML":_vm._s(_vm.details.newsHtml)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2757dd4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/AtomicChain/pages/newsDetails.vue
// module id = null
// module chunks = 